import styled from 'styled-components';
import { BodyRegularS, LightButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ParticipantsCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 56px 0 0;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
      margin: ${theme.layout.spacing.decy} 0 ${theme.layout.spacing.decy} 0;
   `}
`;

export const ContentInNumbers = styled(BodyRegularS)`
  height: 48px;
  text-transform: capitalize;
  border-width: 1px 0px;
  border-style: solid;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[80]};
      padding: ${theme.layout.spacing.centy} 0;
      border-color: ${theme.colors.neutral.primary[20]};
   `}
`;

export const TotalItems = styled(BodyRegularS)`
  font-weight: 700;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[80]};
   `}
`;

export const SearchBoxCont = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
      margin: ${theme.layout.spacing.decy} 0 0 0;
   `}
  input {
    width: 224px;
  }
`;

export const AddButton = styled(LightButton)`
  display: flex;
  margin: 0;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};

    &:hover {
      background: ${theme.colors.primary[10]}
    }
  `}
`;

export const ImportButton = styled(LightButton)`
  display: flex;
  margin: 0 12px 0 auto;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};

    svg {
      transform: rotate(0.5turn);

      path {
        fill: ${theme.colors.accent.blue[100]} !important;
      }
    }

    &:hover {
      background: ${theme.colors.primary[10]}
    }
  `}
`;

export const ParticipantTileWrapper = styled.span`
  margin-right: 5px;
`;
